
/* Saylor's Breed Guides: cards, pop-ups, filters, sort, search, load-more.
   The older parts avoid less-than, greater-than and ampersand characters, a
   leftover from when this lived in the Shopify page editor. As a theme asset
   that is no longer required. */
(function(){
  'use strict';
  function lt(a, b) { return Math.max(a, b) !== a; }
  function lte(a, b) { return !lt(b, a); }
  function both(a, b) { return a ? !!b : false; }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  window.openModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
  };
  window.closeModal = function(id) {
    var el = document.getElementById(id);
    if (el) { el.classList.remove('is-visible'); document.body.style.overflow = ''; }
  };

  /* Close: the X button on any card, or a click on the dimmed background */
  document.addEventListener('click', function(event) {
    var t = event.target;
    var btn = t.closest ? t.closest('.btn-close') : null;
    if (btn) {
      var ov = btn.closest('.breed-modal-overlay');
      if (ov) { ov.classList.remove('is-visible'); document.body.style.overflow = ''; }
      return;
    }
    if (t.classList.contains('breed-modal-overlay')) {
      t.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.breed-modal-overlay.is-visible').forEach(function(m) { m.classList.remove('is-visible'); });
      document.body.style.overflow = '';
    }
  });

  ready(function() {
    document.querySelectorAll('.breed-modal-overlay').forEach(function(modal) {
      if (modal.parentNode !== document.body) { document.body.appendChild(modal); }
    });
    document.querySelectorAll('.breed-modal-overlay .btn-close').forEach(function(b) {
      b.setAttribute('type', 'button'); b.setAttribute('aria-label', 'Close');
    });

    var grid = document.getElementById('breedGrid');
    if (!grid) { return; }

    var allCards = Array.from(grid.querySelectorAll('.card'));
    var search = document.getElementById('breedSearch');
    var filtersWrap = document.getElementById('breedFilters');
    var countEl = document.getElementById('breedCount');
    var clearBtn = document.getElementById('breedClear');
    var surpriseBtn = document.getElementById('breedSurprise');
    var emptyEl = document.getElementById('breedEmpty');
    var emptyClearBtn = document.getElementById('breedEmptyClear');
    var sentinel = document.getElementById('infiniteSentinel');
    var shown = 12;

    grid.addEventListener('click', function(e) {
      var card = e.target.closest('.card');
      if (!card) return;
      var modalId = card.getAttribute('data-modal');
      if (modalId) { window.openModal(modalId); }
    });

    var WEIGHT_BANDS = [
      { max: 15, rec: '1–2' }, { max: 30, rec: '2–3' }, { max: 50, rec: '3–4' },
      { max: 80, rec: '4–6' }, { max: 999, rec: '6–8' }
    ];
    var SIZE_FALLBACK = { small: '1–2', medium: '3–4', large: '4–6', giant: '6–8' };

    allCards.forEach(function(card) {
      var wt = (card.getAttribute('data-wt') || '').trim();
      var avg = null;
      if (wt) {
        var m = wt.match(/^(\d+(?:\.\d+)?)(?:\s*-\s*(\d+(?:\.\d+)?))?$/);
        if (m) { avg = m[2] ? (parseFloat(m[1]) + parseFloat(m[2])) / 2 : parseFloat(m[1]); }
      }
      var size = card.getAttribute('data-size') || '';
      var rec = (avg !== null)
        ? (WEIGHT_BANDS.find(function(b) { return lte(avg, b.max); }) || WEIGHT_BANDS[WEIGHT_BANDS.length - 1]).rec
        : (SIZE_FALLBACK[size] || '3–4');
      card.setAttribute('data-chews', rec);
      card.title = 'Recommended liver chews per day: ' + rec;
    });

    /* Breed facts for filtering and sorting, read from each breed's pop-up
       so the cards themselves never need extra attributes. */

    /* Popularity order, roughly following recent AKC registration rankings,
       with popular doodles slotted in. Breeds not listed follow in page order. */
    var POPULAR = ['frenchie', 'lab', 'golden', 'gsd', 'poodle', 'dachshund', 'bulldog', 'beagle',
      'rottie', 'gsp', 'corgi', 'aussie', 'yorkie', 'cavalier', 'doberman', 'boxer', 'mini-schnauzer',
      'cane-corso', 'great-dane', 'shihtzu', 'husky', 'bernese-mountain-dog', 'pomeranian',
      'boston-terrier', 'havanese', 'mini-goldendoodle', 'labradoodle', 'bernedoodle', 'cavapoo',
      'springer', 'shetland-sheepdog', 'brittany', 'cocker-spaniel', 'mini-american', 'border-collie',
      'belgian-malinois', 'vizsla', 'mastiff', 'chihuahua', 'maltese', 'weimaraner', 'collie',
      'newfoundland', 'ridgeback', 'shiba-inu', 'westie', 'pwd', 'bichon', 'australian-cattle-dog',
      'pug', 'cockapoo', 'pyrenees', 'whippet', 'akita', 'bloodhound', 'samoyed', 'malamute'];

    /* Breed group from the pop-up's CLASS line. Playful labels map to the real group. */
    var GROUP_EXACT = {
      'WORKER / HERDER': 'herding', 'GUARDIAN / HERDER': 'herding', 'GUARDIAN / WORKER': 'working',
      'RETRIEVER / GENIUS': 'non-sporting', 'COMPANION / CLOWN': 'non-sporting',
      'COMPANION / COUCH POTATO': 'non-sporting', 'COMPANION': 'designer', 'HYBRID': 'designer'
    };
    var GROUP_FIRST = {
      'WORKING': 'working', 'SPORTING': 'sporting', 'HERDING': 'herding', 'HOUND': 'hound',
      'TERRIER': 'terrier', 'TOY': 'toy', 'NON-SPORTING': 'non-sporting'
    };
    var APT_OK = ['Ideal Fit', 'Apt', 'Calm indoors'];

    function rangeAvg(text) {
      var nums = (text || '').match(/\d+(?:\.\d+)?/g);
      if (!nums) return null;
      var a = parseFloat(nums[0]);
      var b = nums[1] ? parseFloat(nums[1]) : a;
      return (a + b) / 2;
    }

    function vital(modal, label) {
      var rows = modal.querySelectorAll('.vital-row');
      for (var i = 0; i < rows.length; i++) {
        var strong = rows[i].querySelector('strong');
        if (strong && strong.textContent.trim() === label) {
          var span = rows[i].querySelector('span');
          return span ? span.textContent : '';
        }
      }
      return '';
    }

    var facts = new Map();
    allCards.forEach(function(card, index) {
      var f = {
        index: index,
        name: (card.querySelector('.name') || card).textContent.trim(),
        size: card.getAttribute('data-size') || '',
        energy: card.getAttribute('data-energy') || '',
        shed: card.getAttribute('data-coat') || '',
        group: '', kids: false, pets: false, apt: false,
        scores: {}, weight: null, life: null
      };
      var id = (card.getAttribute('data-modal') || '');
      var pop = POPULAR.indexOf(id.replace(/^modal-/, ''));
      f.popular = pop === -1 ? POPULAR.length + index : pop;

      var modal = id ? document.getElementById(id) : null;
      if (modal) {
        var cls = modal.querySelector('.detail-class span');
        var raw = cls ? cls.textContent.trim().toUpperCase() : '';
        f.group = GROUP_EXACT[raw] || GROUP_FIRST[raw.split('/')[0].trim()] || '';

        modal.querySelectorAll('.ring-col').forEach(function(col) {
          var lbl = col.querySelector('.ring-lbl');
          var val = col.querySelector('.ring span');
          if (lbl && val) { f.scores[lbl.textContent.trim().toLowerCase()] = parseFloat(val.textContent) || 0; }
        });

        /* The compatibility row is always: home fit, kids, other pets */
        var compat = modal.querySelectorAll('.compat-item');
        if (compat[0]) {
          var homeLbl = (compat[0].querySelector('span') || compat[0]).textContent.trim();
          f.apt = compat[0].classList.contains('active') && APT_OK.indexOf(homeLbl) !== -1;
        }
        f.kids = !!(compat[1] && compat[1].classList.contains('active'));
        f.pets = !!(compat[2] && compat[2].classList.contains('active'));

        f.weight = rangeAvg(vital(modal, 'Weight'));
        f.life = rangeAvg(vital(modal, 'Lifespan'));
      }
      facts.set(card, f);
    });

    var DEFAULTS = { q: '', size: '', energy: '', shed: '', group: '', sort: '', kids: false, pets: false, apt: false };
    var state = Object.assign({}, DEFAULTS);

    function readUrl() {
      var p = new URLSearchParams(location.search);
      Object.keys(DEFAULTS).forEach(function(k) {
        if (!p.has(k)) return;
        state[k] = typeof DEFAULTS[k] === 'boolean' ? p.get(k) === '1' : p.get(k);
      });
    }

    function writeUrl() {
      var p = new URLSearchParams(location.search);
      Object.keys(DEFAULTS).forEach(function(k) {
        var v = state[k];
        if (v === DEFAULTS[k]) { p.delete(k); } else { p.set(k, v === true ? '1' : v); }
      });
      var qs = p.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    }

    function syncControls() {
      if (search) { search.value = state.q; }
      if (!filtersWrap) return;
      filtersWrap.querySelectorAll('select[data-key]').forEach(function(sel) {
        var k = sel.getAttribute('data-key');
        sel.value = state[k];
        if (sel.value !== state[k]) { state[k] = ''; sel.value = ''; }
        sel.classList.toggle('is-set', state[k] !== '');
      });
      filtersWrap.querySelectorAll('.bg-chip[data-key]').forEach(function(chip) {
        var on = state[chip.getAttribute('data-key')];
        chip.classList.toggle('active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function matches(card) {
      var f = facts.get(card);
      if (state.size && f.size !== state.size) return false;
      if (state.energy && f.energy !== state.energy) return false;
      if (state.shed && f.shed !== state.shed) return false;
      if (state.group && f.group !== state.group) return false;
      if (state.kids && !f.kids) return false;
      if (state.pets && !f.pets) return false;
      if (state.apt && !f.apt) return false;
      var q = state.q.toLowerCase().trim();
      if (q) {
        var hay = (card.getAttribute('data-name') || '') + ' ' + f.name.toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    }

    function num(v, fallback) { return v === null || v === undefined ? fallback : v; }

    var SORTS = {
      '': function(a, b) { return a.popular - b.popular; },
      az: function(a, b) { return a.name.localeCompare(b.name); },
      small: function(a, b) { return num(a.weight, 999) - num(b.weight, 999); },
      large: function(a, b) { return num(b.weight, -1) - num(a.weight, -1); },
      energy: function(a, b) { return num(b.scores.energy, -1) - num(a.scores.energy, -1); },
      chill: function(a, b) { return num(a.scores.energy, 999) - num(b.scores.energy, 999); },
      cuddle: function(a, b) { return num(b.scores.cuddle, -1) - num(a.scores.cuddle, -1); },
      smart: function(a, b) { return num(b.scores.smarts, -1) - num(a.scores.smarts, -1); },
      life: function(a, b) { return num(b.life, -1) - num(a.life, -1); }
    };

    function sortGrid() {
      var cmp = SORTS[state.sort] || SORTS[''];
      var sorted = allCards.slice().sort(function(a, b) {
        var fa = facts.get(a), fb = facts.get(b);
        return cmp(fa, fb) || fa.popular - fb.popular;
      });
      sorted.forEach(function(card) { grid.appendChild(card); });
      allCards = sorted;
    }

    function visibleCards() {
      return allCards.filter(function(c) { return !c.classList.contains('hidden'); });
    }

    function clampVisible() {
      visibleCards().forEach(function(c, i) { c.style.display = lt(i, shown) ? '' : 'none'; });
    }

    function loadMoreIfNeeded() {
      if (!sentinel) return;
      var visible = visibleCards();
      var rect = sentinel.getBoundingClientRect();
      while (both(lt(shown, visible.length), lte(rect.top, window.innerHeight + 400))) {
        shown += 12;
        clampVisible();
        rect = sentinel.getBoundingClientRect();
      }
    }

    function isFiltered() {
      return Object.keys(DEFAULTS).some(function(k) { return k !== 'sort' && state[k] !== DEFAULTS[k]; });
    }

    function applyFilters() {
      sortGrid();
      var count = 0;
      allCards.forEach(function(card) {
        var ok = matches(card);
        card.classList.toggle('hidden', !ok);
        card.style.display = '';
        if (ok) count++;
      });
      if (countEl) {
        countEl.textContent = isFiltered()
          ? count + ' of ' + allCards.length + ' breeds'
          : allCards.length + ' breeds';
      }
      if (clearBtn) { clearBtn.hidden = !isFiltered(); }
      if (emptyEl) { emptyEl.hidden = count !== 0; }
      if (surpriseBtn) { surpriseBtn.disabled = count === 0; }
      syncControls();
      writeUrl();
      shown = 12;
      clampVisible();
      loadMoreIfNeeded();
    }

    function clearAll() {
      var sort = state.sort;
      state = Object.assign({}, DEFAULTS, { sort: sort });
      applyFilters();
    }

    if (filtersWrap) {
      filtersWrap.addEventListener('change', function(e) {
        var sel = e.target.closest('select[data-key]');
        if (!sel) return;
        state[sel.getAttribute('data-key')] = sel.value;
        applyFilters();
      });
      filtersWrap.addEventListener('click', function(e) {
        var chip = e.target.closest('.bg-chip[data-key]');
        if (!chip) return;
        var k = chip.getAttribute('data-key');
        state[k] = !state[k];
        applyFilters();
      });
    }
    if (clearBtn) { clearBtn.addEventListener('click', clearAll); }
    if (emptyClearBtn) { emptyClearBtn.addEventListener('click', clearAll); }

    /* Surprise me: open a random breed from the current results */
    if (surpriseBtn) {
      surpriseBtn.addEventListener('click', function() {
        var pool = visibleCards();
        if (!pool.length) return;
        var pick = pool[Math.floor(Math.random() * pool.length)];
        var id = pick.getAttribute('data-modal');
        if (id) { window.openModal(id); }
      });
    }

    if (search) {
      search.addEventListener('input', function() { state.q = search.value; applyFilters(); });
    }

    readUrl();

    if (sentinel) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          if (entries.some(function(entry) { return entry.isIntersecting; })) { loadMoreIfNeeded(); }
        }, { rootMargin: '400px 0px' });
        observer.observe(sentinel);
      }
    }
    window.addEventListener('scroll', loadMoreIfNeeded);
    window.addEventListener('resize', loadMoreIfNeeded);

    document.querySelectorAll('img.avatar[data-hover]').forEach(function(img) {
      var primary = img.getAttribute('src');
      var hover = img.getAttribute('data-hover');
      if (!hover) return;
      img.addEventListener('mouseenter', function() { img.src = hover; });
      img.addEventListener('mouseleave', function() { img.src = primary; });
    });

    applyFilters();

    /* Dog Twin quiz deep link: a URL ending in #modal-lab opens the Lab card */
    function openFromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (id.indexOf('modal-') !== 0) return;
      if (document.getElementById(id)) { window.openModal(id); }
    }
    setTimeout(openFromHash, 60);
    window.addEventListener('hashchange', openFromHash);
  });
})();
